import { SuretyAccountId, SuretyAccountStatus } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import { accountQueryKey } from "../account.keys";

export const useAdminReopenAccount = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { patch } = useRequest();

	const mutation = useMutation({
		mutationFn: async () => {
			await patch(
				`/v2/admin/surety/accounts/${accountId}/status`,
				{ status: SuretyAccountStatus.review },
				"none",
			);
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountPreviewsQueryKey() }),
			]);
		},
	});

	return {
		reopenAccount: mutation.mutate,
		reopenAccountError: mutation.error,
		reopenAccountLoading: mutation.isPending,
		dismissReopenAccountError: () => {
			mutation.reset();
		},
	};
};
